import { useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faEdit, faGridRound2Plus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SegmentContext } from 'components/filter/filters-next/SegmentContext';
import * as Input from 'components/input';
import { useCurrentSegment } from 'customHooks/useCurrentSegment';

const SegmentNameForm = () => {
    const isViewingSegment = useCurrentSegment();
    const { isEditing, setIsEditing, name, setName } = useContext(SegmentContext);

    if (isEditing) {
        return (
            <Input.Root>
                <Input.Form
                    autoFocus={true}
                    placeholder={'Enter a segment name'}
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
            </Input.Root>
        );
    }

    return (
        <div className={'flex items-center gap-2'}>
            <FontAwesomeIcon className={'text-blue-500'} icon={faGridRound2Plus} />
            <p className={'text-sm font-medium text-gray-700'}>{isViewingSegment?.name}</p>
            <Button
                variant="none"
                size="sm"
                onClick={() => {
                    setName(isViewingSegment?.name ?? '');
                    setIsEditing(true);
                }}
            >
                <FontAwesomeIcon className={'text-gray-400'} icon={faEdit} />
            </Button>
        </div>
    );
};

export { SegmentNameForm };
